export default "__VITE_ASSET__Dcsor_$L__"